import React from "react";
import styled from "styled-components";
import { BASIC_LINE } from "../../../constants/colors";
import { useWOVN } from "../../../hooks/useWOVN";
import { Button } from "../../atoms/Button";
import { fadein, PopupModalContainer } from "./PopupModal.styles";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

export const LanguageSelectModal: React.FC<Props> = ({
  isOpen,
  handleClose,
}) => {
  const {} = useWOVN();

  if (!isOpen) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        <LanguageListContainer className="wovn-languages">
          <LanguageItem>
            <div className="wovn-switch-template">
              <LanguageSelect>
                <LanguageInput type="radio" />
                wovn-lang-name
              </LanguageSelect>
            </div>
          </LanguageItem>
        </LanguageListContainer>

        <Button btnStyle="primary" text="閉じる" onClick={handleClose} />
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  max-width: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  padding: 20px 15px;
  animation: ${fadein} 0.5s forwards;
`;

const LanguageListContainer = styled.ul`
  list-style: none;
`;

const LanguageItem = styled.li`
  margin-bottom: 0px;
`;

const LanguageSelect = styled.label`
  display: block;
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const LanguageInput = styled.input`
  padding: 10px;
  margin: 0 5px 0 5px;
  border-top: 1px solid ${BASIC_LINE};
`;
